<div class="container-fluid" *ngIf="!isOrganizacion && !isOrgSeleccion">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a style="cursor: pointer;" (click)="antes()" class="btn btn-primary">
                  Volver
              </a>
            </div>
            <h3 class="page-title">Programación Docente</h3>
            <hr class="text-dark">
            <br>
            <h4>Año {{year}}</h4>
        </div>
    </div>
  </div>
  <!-- end page title alt- 248 -->
  <div class="table-responsive mt-4" style="border-radius: 15px;">
    <table class="table table-centered mb-0">
      <thead class="table-primary">
        <tr>
          <th>N°</th>
          <th>Ámbito</th>
          <th class="text-center">Meta Asignada</th>
          <th class="text-center">Meta Programada</th>
          <th class="text-center">Seleccione las Entidad(es) de Trabajo</th>
          <!--th>Acción</th-->
        </tr>
      </thead>
      <tbody>
        <ng-content *ngFor="let re of resultado; let i = index">
          <tr>
            <td>{{i+1}}</td>
            <td>{{re.ambito}}</td>
            <td class="text-center">{{re.meta_asignada}}</td>
            <td class="text-center">{{re.meta_programada}}</td>
            <td class="text-center">
              <!--a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="interempresa(re.id_ambito, re.ambito)">Entidad(es) de Trabajo</a-->
              <a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="interempresa_2(re.id_ambito, re.ambito)">Entidad(es) de Trabajo</a>
            </td>
          </tr>
        </ng-content>
      </tbody>
    </table>
  </div>
</div>



<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>


<!--ng-template #mdlOrganizacion let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Seleccione Organizaciones</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="cierra()"></button>
	</div>
	<div class="modal-body">
		<div class="modal-body">
      <div class="row">
        <div class="col-12">
          <input class="form-control" type="text" id="buscar" [(ngModel)]="nombreBusqueda" (input)="buscarOrganizaciones()" placeholder="Buscar organización...">
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center">
          <strong class="{{color}}">{{mensaje_calulo}}:</strong> {{ calculo_cupo }}
        </div>
      </div>
      <div class="row mt-3">
        <ng-content  *ngFor="let l of filtroOrganizaciones, let i=index">
          <div class="col-9 mb-3">
            <div class="form-check">
              <input class="form-check-input"
              type="checkbox"
              (change)="cargaChk(i,l.id_organizacion,$event.target)"
              value="{{l.id_organizacion}}"
              id="chkProgama"
              name="programas"
              [checked]="organizacionesSeleccionadas.includes(l.id_organizacion)">
              <label class="form-check-label" for="programas">{{l.organizacion}}</label>
            </div>
          </div>
          <div class="col-3 mb-3">
            <input class="form-control" type="text" id="cupo_{{l.id_organizacion}}" placeholder="CUPO" mask="00" [disabled]="i != indiceADesactivar" #cupo>
          </div>
        </ng-content>
      </div>

    </div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="aceptar()" [disabled]="calculo_cupo > 50 || calculo_cupo == 0">Aceptar</button>
		<button type="button" class="btn btn-secondary" (click)="cierra()">Cerrar</button>
	</div>
</ng-template-->



<app-organizacion-seleccion *ngIf="isOrgSeleccion"
[year]="year"
[user]="user"
[id_ambito]="id_ambito"
[nom_ambito]="nom_ambito"
(vuelve)="volver($event)"></app-organizacion-seleccion>


<!-- Esta no va a ir, apenas termine el modulo -->
<!--app-organizaciones *ngIf="isOrganizacion"
[year]="year"
[user]="user"
[id_empresas]="organizacionesSeleccionadas"
[id_ambito]="id_ambito"
[nom_ambito]="nom_ambito"
[cupo]="calculo_cupo"
(vuelve)="volver($event)"></app-organizaciones-->
